import axios from 'axios';

// آدرس Backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/backend';

// ساخت instance اصلی axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 ثانیه
});

// Interceptor برای اضافه کردن Token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor برای مدیریت خطاها
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // خطای از سمت سرور
      const { status, data } = error.response;
      
      if (status === 401) {
        // توکن منقضی شده
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
      
      return Promise.reject(data);
    } else if (error.request) {
      // درخواست ارسال شده ولی جوابی نیومده
      return Promise.reject({
        error: 'خطا در برقراری ارتباط با سرور. لطفاً اتصال اینترنت خود را بررسی کنید.'
      });
    } else {
      // خطای دیگه
      return Promise.reject({
        error: 'خطای غیرمنتظره رخ داد.'
      });
    }
  }
);

// =====================================
// Auth APIs
// =====================================
export const authAPI = {
  sendOTP: (phone) => api.post('/api/auth/send-otp.php', { phone }),
  
  verifyOTP: (phone, code, name = null, age = null, gender = null) => 
    api.post('/api/auth/verify-otp.php', { phone, code, name, age, gender }),
  
  checkAuth: () => api.get('/api/auth/check-auth.php'),
};

// =====================================
// Questions APIs
// =====================================
export const questionsAPI = {
  getByType: (testType) => api.get(`/api/questions/get-by-type.php?test_type=${testType}`),
  
  skipQuestion: (questionId) => api.post('/api/questions/skip.php', { question_id: questionId }),
};

// =====================================
// Tests APIs
// =====================================
export const testsAPI = {
  create: (testType, answers) => api.post('/api/tests/create.php', { test_type: testType, answers }),
  
  get: (testUuid) => api.get(`/api/tests/get.php?uuid=${testUuid}`),
  
  getDetail: (testId) => api.get(`/api/tests/detail.php?id=${testId}`),
  
  list: () => api.get('/api/tests/list.php'),
  
  delete: (testId) => api.delete('/api/tests/delete.php', { data: { test_id: testId } }),
  
  search: (query, testType = null) => {
    let url = `/api/tests/search.php?q=${encodeURIComponent(query)}`;
    if (testType) url += `&type=${testType}`;
    return api.get(url);
  },
  
  extend: (testId, days) => api.post('/api/tests/extend.php', { test_id: testId, days }),
};

// =====================================
// Participants APIs
// =====================================
export const participantsAPI = {
  submit: (testUuid, participantName, answers) => 
    api.post('/api/participants/submit.php', { 
      test_uuid: testUuid, 
      participant_name: participantName, 
      answers 
    }),
  
  getResults: (testId) => api.get(`/api/participants/get-results.php?test_id=${testId}`),
  
  getDetail: (participantId) => api.get(`/api/participants/detail.php?participant_id=${participantId}`),
};

// =====================================
// Notifications APIs
// =====================================
export const notificationsAPI = {
  list: () => api.get('/api/notifications/list.php'),
  
  markRead: (notificationId = null) => 
    api.post('/api/notifications/mark-read.php', { notification_id: notificationId }),
  
  delete: (notificationId = null) => 
    api.delete('/api/notifications/delete.php', { data: { notification_id: notificationId } }),
};

// =====================================
// Payments APIs
// =====================================
export const paymentsAPI = {
  create: (packageType) => api.post('/api/payments/create.php', { package_type: packageType }),
  
  // verify مستقیماً در مرورگر فراخوانی نمیشه (callback از درگاه)
};

// =====================================
// Dashboard APIs
// =====================================
export const dashboardAPI = {
  getStats: () => api.get('/api/dashboard/stats.php'),
};

// =====================================
// User APIs
// =====================================
export const userAPI = {
  getProfile: () => api.get('/api/user/profile.php'),
  
  updateProfile: (profile) => api.put('/api/user/profile.php', profile),

  uploadAvatar: (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    return api.post('/api/user/avatar.php', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  linkBalePhone: (phone, code) => api.post('/api/user/link-bale-phone.php', { phone, code }),
  requestBaleContact: () => api.post('/api/user/request-bale-contact.php'),
};

// =====================================
// Leaderboard APIs
// =====================================
export const leaderboardAPI = {
  get: (testUuid) => api.get(`/api/leaderboard/get.php?test_uuid=${testUuid}`),
};
export const storyAPI = {
  getTemplates: () => api.get('/api/story/templates.php'),
  
  generate: (testUuid, templateKey) => 
    api.post('/api/story/generate.php', { test_uuid: testUuid, template_key: templateKey })
};

export default api;
